module.exports = __webpack_public_path__ + "img/banana.c6da2ee.png";